import { Layout } from '@/components/Layout';
import { useState } from 'react';
import './account-screen.styles.css';
import { TabPanel, TabView } from 'primereact/tabview';
import SettingsGeneralTab from './SettingsGeneralTab';
import SettingsNotificationTab from './SettingsNotificationTab';
import { TabHelper } from '@/common/TabHelper';
import { axiosInstance } from '@/services/axios.service';
import { useQuery } from '@tanstack/react-query';
import { GenericResponse } from '@/common/common_utils';
import { X4bUserSettingDto } from './X4bUserSettingDto';
import { ENDPOINTS } from '@/constants/endpoints';

const SettingsScreen = () => {
	const [currentTab, setCurrentTab] = useState(0);

	const settingQ = useQuery({
		queryKey: ['Account.UserSettings'],
		queryFn: async () => {
			const result = await axiosInstance.post<GenericResponse<X4bUserSettingDto>>(ENDPOINTS['/api/X4bUser/GetUserSetting'], {});
			return result.data;
		}
	});

	return (
		<Layout>
			{settingQ.isLoading ? (
				<div className="account-container">
					<div className="account-loading-spinner" />
				</div>
			) : (
				<div className="w-full">
					<h1 className="account-title">Settings</h1>
					<TabView
						activeIndex={currentTab}
						onTabChange={(e) => setCurrentTab(e.index)}
						// TODO: refactor that by making separate tab component.
						pt={{
							panelContainer: { className: 'peoplePanelContainer !py-6 px-0' },
							nav: { className: 'peopleTabViewNavUl' },
							inkbar: { className: 'peopleTabInkBar' },
						}}
					>
						<TabPanel
							pt={TabHelper.TabPanelProps}
							header={<div tabIndex={0}>General</div>}
							children={(<SettingsGeneralTab settingQ={settingQ} />)}
						/>
						<TabPanel
							pt={TabHelper.TabPanelProps}
							header={<div tabIndex={1}>Notification</div>}
							children={(<SettingsNotificationTab />)}
						/>
					</TabView>
				</div>
			)}
		</Layout>
	);
};

export default SettingsScreen;
